import slugify from './slugify'

export const formatJobUrl = (id: string, name: string, pathname: string) => {
  const formattedId = id.slice(0, 6)
  const formattedName = slugify(name)

  return `${pathname}/${formattedId}-${formattedName}`
}
